/**
 * ⏳ Kurz nicht erreichbarer Server (Deploy/Neustart, WLAN-Aussetzer) → warten und nachholen statt aufgeben
 * (23.10.2026, Wunsch Philipp: „wenn nicht erreichbar, kommt das in die Warteschlange").
 *
 * Wiederholt wird NUR, wenn die Anfrage den Server sicher nicht erreicht hat: Netzfehler oder 502/503 (nginx während
 * des Neustarts). Bei einer Zeitüberschreitung kann eine Buchung schon durch sein → dort wird nicht wiederholt.
 */

/** Ergebnis eines ruf()-Aufrufs (vinted/dhlBridge): Server war nicht erreichbar? */
export function serverWeg(r) {
  return !!(r && r.ok === false && r.reason === 'offline' && !r.zeitueberschreitung && (r.netzweg || r.status === 502 || r.status === 503));
}

const schlafen = (ms) => new Promise((res) => setTimeout(res, ms));

/**
 * fn() so lange wiederholen, wie der Server nicht erreichbar ist — höchstens maxMs (Standard 90 s, ein API-Neustart
 * dauert ~5–10 s, der Erkennungsdienst bis ~60 s). onWarte({ versuch, seitMs, maxMs }) für die Anzeige.
 * Liefert das letzte Ergebnis (nach Ablauf also wieder { ok:false, reason:'offline' } → der Aufrufer fällt zurück wie bisher).
 */
export async function mitWiederholung(fn, { maxMs = 90000, onWarte } = {}) {
  const start = Date.now();
  let versuch = 0;
  let r = await fn();
  while (serverWeg(r) && Date.now() - start < maxMs) {
    versuch += 1;
    try { if (onWarte) onWarte({ versuch, seitMs: Date.now() - start, maxMs }); } catch { /* */ }
    await schlafen(Math.min(1000 * versuch, 5000)); // 1 s, 2 s, … höchstens 5 s Abstand
    r = await fn();
  }
  return r;
}
